import { DropZone as CXDropZone } from '@sanlamcx/react-ui-next-drop-zone';

export const DropZone = CXDropZone;
